module.exports = __webpack_public_path__ + "static/img/EcoStruxure-IT-Expert-PNG.d597cf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/EcoStruxure-IT-Expert-PNG.jpg
// module id = l3Rb
// module chunks = 0